<template>
  <v-container style="position:relative;">
    <div
      data-test="loadingPage"
      class="normal-screen justify-center
      align-center
      d-flex"
    >
      <v-progress-circular
        indeterminate
        width="8"
        size="160"
        color="muted"
        style="overflow: hidden;"
      />
      <h1 class="mt-12" style="font-weight:bold;color:black;font-size: 16px;">
        {{
          customText ||
            $t("common:loading.message", "Loading") + " " + translatedName
        }}
      </h1>
    </div>
  </v-container>
</template>
<script>
import { defineComponent, computed, onMounted, getCurrentInstance } from "vue";
import TranslatedComponentName from "@/utils/translatedComponentName";

export default defineComponent({
  name: "AppLoadingPage",
  props: {
    customText: {
      type: String,
      default: null
    }
  },
  setup(props, ctx) {
    const instance = getCurrentInstance();

    const translatedName = computed(() => {
      return TranslatedComponentName(instance.proxy.$route.name);
    });

    onMounted(() => {
      ctx.emit("mounted");
    });

    return {
      translatedName
    };
  }
});
</script>
<style scoped>
.normal-screen {
  min-height: 35rem;
  flex-direction: column;
}
</style>
